var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"header",attrs:{"src":"https://www.certificados.hospitaldoispinheiros.com.br/img/logo-home.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }